<div [formGroup]="orderForm">

  <button mat-raised-button  color="primary" (click)="addPoint()">Adicionar Opção</button>

  <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
    <div [formGroupName]="i">
      <mat-card>
        <mat-form-field>
          <input matInput formControlName="description" placeholder="Nome da opção do parametro">
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="remove(i)" aria-label="Remover">
          <mat-icon>remove_circle</mat-icon>
        </button>
        <app-coordinates formControlName="coordinates"></app-coordinates>
      </mat-card>

    </div>
    <br>

  </div>

</div>